import { BpAnchor } from '../../../../shared/components/text/anchor/BpAnchor'
import { Tooltip } from 'antd'
import React from 'react'

interface PageCellProps {
  page?: string
}

export const PageCell = ({ page }: PageCellProps) => {
  if (!page) {
    return (
      <span
        className={
          'table rounded-md bg-danger-300 px-2 text-[10px] font-semibold uppercase leading-5 text-danger'
        }
      >
        not found
      </span>
    )
  }

  return (
    <div className='w-96 overflow-hidden text-ellipsis'>
      <BpAnchor
        className='flex-1 text-ellipsis whitespace-nowrap leading-5'
        href={page}
        target='_blank'
      >
        <Tooltip title={page.split('?')[0]}>{page.split('?')[0]}</Tooltip>
      </BpAnchor>
    </div>
  )
}
